import { Container } from "./styles";
import Photo from "../../assets/profile_long_optimized.webp";
import ScrollAnimation from "react-animate-on-scroll";
import { useLanguage } from "../../i18n/LanguageContext";

export function About() {
  const { t } = useLanguage();

  return (
    <Container id="about">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft">
          <h2>{t.about.heading}</h2>
        </ScrollAnimation>
        {t.about.paragraphs.map((paragraph, index) => (
          <ScrollAnimation animateIn="fadeInLeft" delay={(index + 1) * 100} key={index}>
            <p>{paragraph}</p>
          </ScrollAnimation>
        ))}
        <ScrollAnimation animateIn="fadeInLeft" delay={0.5 * 1000}>
          <dl className="skills">
            {t.about.skills.map((skill) => (
              <div className="skill-row" key={skill.term}>
                <dt>{skill.term}</dt>
                <dd>{skill.value}</dd>
              </div>
            ))}
          </dl>
        </ScrollAnimation>
      </div>
      <div className="about-image">
        <ScrollAnimation animateIn="fadeInRight" delay={0.2 * 1000}>
          <img src={Photo} alt={t.about.photoAlt} loading="lazy" />
        </ScrollAnimation>
      </div>
    </Container>
  );
}
